import {useEffect, useState, useRef} from '@wordpress/element';
import {registerPaymentMethod} from '@woocommerce/blocks-registry';
import {getSetting} from '@woocommerce/settings';
import {
    getBillingDetailsFromAddress,
    initStripe as loadStripe
} from '@wc-stripe/blocks-utils';
import {Elements} from '@stripe/react-stripe-js';
import {PaymentMethodLabel, PaymentMethod} from '@wc-stripe/blocks-components';
import SavedCardComponent from '../saved-card-component';
import PaymentElementComponent from './payment-element';
import LegacyCardElement from "./legacy-card-element";

const data = getSetting('stripe_cc_data');

const CreditCardContent = (props) => {
    const [error, setError] = useState(false);
    useEffect(() => {
        loadStripe.catch(error => {
            setError(error);
        })
    }, [setError]);
    if (error) {
        throw new Error(error);
    }
    if (data.isPaymentElement) {
        return (
            <PaymentElementComponent {...props}/>
        )
    }
    return (
        <Elements stripe={loadStripe} options={data.elementOptions}>
            <LegacyCardElement {...props}/>
        </Elements>
    );
};

registerPaymentMethod({
    name: data.name,
    label: <PaymentMethodLabel
        title={data.title}
        paymentMethod={data.name}
        icons={data.icons}/>,
    ariaLabel: 'Credit Cards',
    canMakePayment: () => loadStripe,
    content: <PaymentMethod content={CreditCardContent} data={data}/>,
    savedTokenComponent: <SavedCardComponent data={data}/>,
    edit: <PaymentMethod content={CreditCardContent} data={data}/>,
    supports: {
        showSavedCards: data.showSavedCards,
        showSaveOption: data.showSaveOption,
        features: data.features
    }
})